/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import axios from 'axios';
import {
  TextField,
  Grid,
  Button,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Checkbox,
} from '@mui/material';
import Title from '../dashboard/Title';
import { Layer } from '../../types';
import config from '../../config';

interface Record {
  id: number;
  nameVisitor1: string;
  nameVisitor2: string;
  created: Date;
}

const sortByCreatedAsc = (records: Record[]) =>
  [...records].sort(
    (a, b) => new Date(a.created).getTime() - new Date(b.created).getTime(),
  );

export function VisitorRecord(props: any) {
  const { layer1, layer2 } = props;

  const [visitorRecords, setVisitorRecords] = React.useState<Record[]>([]);
  const [visitor1, setVisitor1] = React.useState('');
  const [visitor2, setVisitor2] = React.useState('');
  const [error, setError] = React.useState({
    status: false,
    message: '',
  });
  const [selected, setSelected] = React.useState<readonly number[]>([]);
  const [layerId, setLayerId] = React.useState(-1);

  const getLayerId = async () => {
    try {
      let res = await axios.get(
        `${config.api.url}/mdsouth/layers/${layer1}/${layer2}`,
      );
      setLayerId(res.data.layers[0].id);

      res = await axios.get(
        `${config.api.url}/mdsouth/visitors?layerId=${res.data.layers[0].id}`,
      );
      setVisitorRecords(sortByCreatedAsc(res.data));
    } catch (error) {
      console.log(error);
    }
  };

  const handleVisit1Changed = (e: React.ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value;
    setVisitor1(text);
  };

  const handleVisit2Changed = (e: React.ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value;
    setVisitor2(text);
  };

  const handleUpdateVisitors = async () => {
    if (visitor1 === '') {
      setError({
        status: true,
        message: '방문자 이름을 넣어주세요',
      });
      return;
    }
    setSelected([]);

    try {
      const { data } = await axios.post(`${config.api.url}/mdsouth/visitors`, {
        nameVisitor1: visitor1,
        nameVisitor2: visitor2,
        created: new Date(),
        layerId,
      });
      setVisitorRecords(
        sortByCreatedAsc([
          ...visitorRecords,
          {
            id: data.id,
            nameVisitor1: visitor1,
            nameVisitor2: visitor2,
            created: new Date(),
          },
        ]),
      );
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    getLayerId();
  }, [layer1, layer2]);

  const handleClick = (event: React.MouseEvent<unknown>, id: number) => {
    const selectedIndex = selected.indexOf(id);
    if (selectedIndex === -1) {
      setSelected([...selected, id]);
    } else {
      setSelected([
        ...selected.slice(0, selectedIndex),
        ...selected.slice(selectedIndex + 1),
      ]);
    }
  };

  const isSelected = (id: number) => selected.indexOf(id) !== -1;

  const handleDeleteSelected = async () => {
    try {
      selected.forEach(async (id: number) => {
        // for selected record, let's delete
        await axios.delete(`${config.api.url}/mdsouth/visitors/${id}`);
      });
      const newRecords = visitorRecords.filter((record: Record) => {
        return selected.indexOf(record.id) === -1;
      });
      setVisitorRecords(newRecords);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Title>방문자기록</Title>
      <Table size="small" sx={{ mb: 4 }}>
        <TableHead>
          <TableRow>
            <TableCell>{}</TableCell>
            <TableCell>방문시간</TableCell>
            <TableCell>방문자1</TableCell>
            <TableCell>방문자2</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {visitorRecords.map((record: Record, index: number) => {
            const isItemSelected = isSelected(record.id);

            const created = new Date(
              new Date(record.created).getTime() -
                new Date(record.created).getTimezoneOffset() * 60000,
            );
            return (
              <TableRow
                key={record.id}
                role="checkbox"
                aria-checked={isItemSelected}
                selected={isItemSelected}
                onClick={event => handleClick(event, record.id)}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    color="primary"
                    checked={isItemSelected}
                    inputProps={{
                      'aria-labelledby': index.toString(),
                    }}
                  />
                </TableCell>
                <TableCell>
                  {created.toLocaleString('ko-KR', { timeZone: 'UTC' })}
                </TableCell>
                <TableCell>{record.nameVisitor1}</TableCell>
                <TableCell>{record.nameVisitor2}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            error={error.status}
            fullWidth
            required
            size="small"
            id="outlined-required"
            label="방문자1"
            placeholder="방문자1의 이름을 넣어주세요"
            onChange={handleVisit1Changed}
            helperText={error.message}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id="outlined-required"
            label="방문자2"
            placeholder="방문자2의 이름을 넣어주세요"
            onChange={handleVisit2Changed}
          />
        </Grid>
        <Grid item>
          <Button variant="outlined" onClick={handleUpdateVisitors}>
            방문자저장
          </Button>
        </Grid>
        <Grid item>
          <Button variant="outlined" onClick={handleDeleteSelected}>
            선택기록삭제
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
